<template>
  <div id="commonDownloadGuide">
    <van-popup v-model="showDownloadGuide" round>
      <div class="close">
        <img
          src="@/assets/scrrenClose.png"
          alt=""
          @click="showDownloadGuide = false"
        />
      </div>
      <img src="@/assets/downloadIcon.png" alt="" />
      <p>Download the APP to get full services.</p>
      <common-btn class="btn" :click="downLoad">Get APP Now</common-btn>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'commonDownloadGuide',
  props: {
    value: { type: Boolean, default: true }
  },
  data () {
    return {}
  },
  computed: {
    showDownloadGuide: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    downLoad () {
      this.$openLinkInNewWindow()
    }
  }
}
</script>

<style scoped lang='less'>
.van-popup {
  width: 75%;
  padding: 28px 20px 22px;
  .close {
    position: absolute;
    top: 6px;
    right: 20px;
    img {
      width: 18px;
      height: 18px;
    }
  }
  img {
    width: 86px;
    height: 83px;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #12033a;
    margin-top: 12px;
    margin-bottom: 20px;
  }
  .btn {
    padding: 12px;
  }
}
</style>
